module.exports = __webpack_public_path__ + "img/view-report.c181ff53.svg";